import { REQUEST_FETCH_COMPANY, REQUEST_UPDATE_COMPANY } from 'actions/actionTypes';
import * as AppAction from 'actions/appActions';
import * as ComparisonSurveyActions from 'actions/backend/engagementSurvey/comparisonActions';
import * as SurveyAction from 'actions/backend/engagementSurvey/resultActions';
import * as SegmentAction from 'actions/backend/segmentActions';
import * as UserAction from 'actions/backend/userActions';
import * as Action from 'actions/backyard/companyActions';
import * as FlashMessageAction from 'actions/flashMessageActions';
import * as API from 'apis/backend';
import { all, call, fork, put, select, take } from 'redux-saga/effects';
import { CompanyUpdateParamsTypes } from 'types/backend/company';

function* runRequestFetchCompany(id: string) {
  const { rootPath } = yield select((state) => state.app);
  const { payload, error, newXCSRFToken } = yield call(API.requestFetchCompany, rootPath, id);
  if (payload && !error) {
    // companyが変わったらリセット
    if (rootPath === 'backyard') {
      yield all([
        put(SurveyAction.resetSurveyState()),
        put(ComparisonSurveyActions.resetComparisonSurveyData()),
        put(UserAction.resetUsersState()),
        put(SegmentAction.resetSegmentGroupsState()),
        put(
          FlashMessageAction.addFlashMessage({
            type: 'success',
            message: `「${payload.name}」をセットしました。`,
          }),
        ),
      ]);
    }
    yield all([
      put(AppAction.setXCSRFToken(newXCSRFToken)),
      put(Action.successFetchCompany(payload)),
    ]);
  } else {
    yield all([
      put(Action.failureFetchCompany()),
      put(
        FlashMessageAction.addFlashMessage({
          type: 'error',
          message: '企業情報の取得に失敗しました。',
        }),
      ),
    ]);
  }
}

function* handleRequestFetchCompany() {
  while (true) {
    const { id } = yield take(REQUEST_FETCH_COMPANY);
    yield fork(runRequestFetchCompany, id);
  }
}

function* runRequestUpdateCompany(params: CompanyUpdateParamsTypes) {
  const { xCSRFToken } = yield select((state) => state.app);
  const { payload, newXCSRFToken, error } = yield call(
    API.requestUpdateCompany,
    params,
    xCSRFToken,
  );
  if (payload && !error) {
    yield all([
      put(AppAction.setXCSRFToken(newXCSRFToken)),
      put(Action.successUpdateCompany(payload)),
      put(
        FlashMessageAction.addFlashMessage({
          type: 'success',
          message: '編集を保存しました。',
        }),
      ),
    ]);
  } else {
    yield put(Action.failureUpdateCompany());
    yield put(
      FlashMessageAction.addFlashMessage({
        type: 'error',
        message: '編集に失敗しました。',
      }),
    );
  }
}

function* handleUpdateCompany() {
  while (true) {
    const { params } = yield take(REQUEST_UPDATE_COMPANY);
    yield fork(runRequestUpdateCompany, params);
  }
}

export default function* companySaga() {
  yield fork(handleRequestFetchCompany);
  yield fork(handleUpdateCompany);
}
